import React from 'react'
import { Box, Grid, Typography, Button, LinearProgress, Link } from '@material-ui/core'
import { ArrowForward as ArrowForwardIcon } from '@material-ui/icons'
import strings from 'strings'
import EmptyState from 'components/ds/EmptyState'
import { STATUS_COLORS, agendaTagStyle } from './udHelpers'

const UDPendingRow = ({ pending, agenda, stats, classes, history }) => {
    return (
        <Grid container spacing={2} style={{ marginBottom: 16 }}>
            <Grid item xs={12} md={7}>
                <Box className={classes.card}>
                    <Box className={classes.tableHeader}>
                        <Typography className={classes.tableTitle}>{strings.UD.PENDING_APPLICATIONS.replace('{count}', pending.length)}</Typography>
                        <Typography className={classes.tableSubtitle}>
                            {stats.checksStuckOver24h ? strings.UD.STUCK_OVER_24H.replace('{count}', stats.checksStuckOver24h) : strings.UD.SORTED_BY_OLDEST}
                        </Typography>
                    </Box>
                    {pending.length === 0 && (
                        <EmptyState kind="all-clear" compact description={strings.UD.NO_PENDING_APPLICATIONS} />
                    )}
                    {pending.map((app) => {
                        const dotColor = STATUS_COLORS[app.status] || 'var(--neutral-400)'
                        return (
                            <Box key={app.applicationUuid} className={classes.appRow}>
                                <Box style={{ flex: '0 0 180px', minWidth: 0 }}>
                                    <Typography className={classes.appName} noWrap>{app.businessName || strings.UD.UNNAMED_APPLICATION}</Typography>
                                    <Typography className={classes.appMeta}>{strings.UD.APP_META.replace('{type}', app.type || '—')}</Typography>
                                </Box>
                                <Box style={{ flex: '0 0 130px', display: 'flex', alignItems: 'center' }}>
                                    <span className={classes.statusDot} style={{ backgroundColor: dotColor }} />
                                    <Typography className={classes.statusLabel}>{app.status}</Typography>
                                </Box>
                                <Box style={{ flex: 1, margin: '0 12px' }}>
                                    <Typography className={classes.checksLabel}>
                                        {app.checksTotal === 0
                                            ? strings.UD.NO_CHECKS_YET
                                            : strings.UD.CHECKS_OF.replace('{completed}', app.checksCompleted).replace('{total}', app.checksTotal)}
                                    </Typography>
                                    <LinearProgress
                                        variant="determinate"
                                        value={app.completionPct || 0}
                                        className={`ud-progress pct-${Math.floor((app.completionPct || 0) / 10) * 10}`}
                                    />
                                </Box>
                                <Typography className={classes.pctLabel}>{app.completionPct || 0}%</Typography>
                                <Button
                                    className={classes.openBtn}
                                    endIcon={<ArrowForwardIcon style={{ fontSize: 14 }} />}
                                    onClick={() => history.push(`/applicant/${app.applicationUuid}`)}
                                    style={{ marginLeft: 12 }}
                                >
                                    {strings.UD.OPEN}
                                </Button>
                            </Box>
                        )
                    })}
                </Box>
            </Grid>
            <Grid item xs={12} md={5}>
                <Box className={classes.card}>
                    <Typography className={classes.tableTitle} style={{ marginBottom: 16 }}>{strings.UD.TODAY_AGENDA}</Typography>
                    {agenda.length === 0 && (
                        <EmptyState kind="all-clear" compact description={strings.UD.NOTHING_PENDING} />
                    )}
                    {agenda.map((item, i) => (
                        <Box key={i} className={classes.agendaItem} style={{ display: 'flex', gap: 12 }}>
                            <Box style={{ flex: 1 }}>
                                {item.link ? (
                                    // Items with a destination (credit memo approvals) open it.
                                    <Link
                                        component="button"
                                        className={classes.agendaTitle}
                                        style={{ textAlign: 'left', display: 'block' }}
                                        onClick={() => history.push(item.link)}
                                    >
                                        {item.checkName} · {item.businessName}
                                    </Link>
                                ) : (
                                    <Typography className={classes.agendaTitle}>{item.checkName} · {item.businessName}</Typography>
                                )}
                                <Typography className={classes.agendaSub}>{item.description || ''}</Typography>
                                {item.tagLabel && (
                                    <span
                                        className={classes.agendaTag}
                                        style={agendaTagStyle(item.tagStyle)}
                                    >
                                        {item.tagLabel}
                                    </span>
                                )}
                            </Box>
                        </Box>
                    ))}
                </Box>
            </Grid>
        </Grid>
    )
}

export default UDPendingRow
